export default __webpack_public_path__ + "static/media/showVoucher.49dd9fc3.jpg";